<template>
  <div
    class="lista-piatti-categoria"
    v-bind:class="{empty: dishes.length===0}"
    v-bind:id="category.name"
    v-if="isCategorySelected || !isMacroCategorySelected"
  >
    <div class="title">
      <div class="icon-container">
        <img v-bind:src="category.mainIcon" />
      </div>
      <h2>{{category.label}}</h2>
    </div>
    <MensaDish v-bind:dish="dish" v-for="dish in filteredDishes" v-bind:key="dish.id"></MensaDish>
  </div>
</template>
<script>
import MensaDish from './MensaDish';
export default {
  name: 'disheslist',
  components: { MensaDish },
  props: ['category', 'dishes', 'orderCategories'],
  computed: {
    filteredDishes() {
      console.log(this.dishes);

      return !this.isCategorySelected
        ? this.dishes
        : this.dishes.filter(d => d.orderQuantity > 0);
    },
    isCategorySelected() {
      return this.orderCategories.indexOf(this.category.name) !== -1;
    },
    currentMacrocategory() {
      return macroCategories.find(mc => {
        return mc.categories.filter(c => c === this.category.name).length;
      });
    },
    isMacroCategorySelected() {
      console.log(this.macrocategoriesSelected);
      console.log(this.currentMacrocategory);

      return this.macrocategoriesSelected.filter(
        mc => mc.id === this.currentMacrocategory.id
      ).length;
    },
    macrocategoriesSelected() {
      return macroCategories.filter(mc => {
        return mc.categories.filter(c => this.orderCategories.indexOf(c) !== -1)
          .length;
      });
    }
  }
};
const mainCategories = ['primi', 'secondi', 'piatti freddi'];
const sideDishCategories = ['contorni', 'panini'];
const fruitCategories = ['frutta'];
const macroCategories = [
  { name: 'main', categories: mainCategories, id: 1 },
  { name: 'side', categories: sideDishCategories, id: 2 },
  { name: 'fruit', categories: fruitCategories, id: 3 }
];
</script>
<style lang="scss" scoped>
.lista-piatti-categoria {
  margin: 0 20px 30px;
  position: relative;
  &.empty {
    margin-bottom: 16px;
    &:nth-last-child(1) {
      margin-bottom: 21px;
    }
  }
  &:not(.empty)::after {
    content: '';
    background-image: url('../assets/images/mensa/card-mensa-bck.png');
    background-position: bottom;
    background-repeat: repeat-x;
    position: absolute;
    width: 100%;
    bottom: -9px;
    left: 0;
    height: 10px;
  }
  .title {
    h2 {
      font-size: 1.07em;
      letter-spacing: 1px;
      margin: 0;
      font-weight: 600;
    }
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 15px;
    @include shadow-bottom;
    margin: 0 0 10px;
    .icon-container {
      margin-right: 10px;
      width: 36px;
      height: 36px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
